module.exports = __webpack_public_path__ + "img/free-trial.88310cad.svg";